const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:1337';
const SOLVER_URL = process.env.REACT_APP_SOLVER_URL || 'http://localhost:5000';
const SOLVER_API_MODE =
  process.env.REACT_APP_SOLVER_API_MODE || (process.env.NODE_ENV === 'production' ? 'php' : 'python');
const SOLVER_PHP_API_URL = process.env.REACT_APP_SOLVER_PHP_API_URL || '/api';

export const sitePath = (path) => `${API_URL}/api/site${path}`;

export const fetchJson = async (url, options = {}) => {
  const response = await fetch(url, options);

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || response.statusText);
  }

  return response.json();
};

const postJson = async (url, payload, options = {}) => {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    ...options,
  });

  const json = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(json?.explanation || json?.message || response.statusText);
  }
  return json;
};

const shouldUsePhpSolverApi = () => SOLVER_API_MODE === 'php';

const solverFamilyPath = (solverFamily) => {
  if (['snowflake', 'tridoku', 'number-kingdoms', 'battleship'].includes(solverFamily)) {
    return solverFamily;
  }
  throw new Error('Unknown book solver family.');
};

export const unlockBookSolver = ({ solverFamily, bookCode, accessKey }) => {
  if (shouldUsePhpSolverApi()) {
    return postJson(
      `${SOLVER_PHP_API_URL}/unlock.php`,
      {
        bookId: bookCode,
        accessKey,
      },
      { credentials: 'same-origin' }
    );
  }

  return postJson(`${SOLVER_URL}/api/solve/${solverFamilyPath(solverFamily)}/access`, {
    bookCode,
    accessKey,
  });
};

export const loadBookPuzzle = ({ solverFamily, bookCode, accessToken, puzzleNumber }) => {
  if (shouldUsePhpSolverApi()) {
    return postJson(
      `${SOLVER_PHP_API_URL}/step.php`,
      {
        action: 'load',
        bookId: bookCode,
        puzzleId: String(puzzleNumber),
      },
      { credentials: 'same-origin' }
    );
  }

  return postJson(`${SOLVER_URL}/api/solve/${solverFamilyPath(solverFamily)}/load`, {
    bookCode,
    accessToken,
    puzzleNumber,
  });
};

export const fetchBookStep = ({
  solverFamily,
  bookCode,
  accessToken,
  puzzleNumber,
  stepIndex,
}) => {
  if (shouldUsePhpSolverApi()) {
    return postJson(
      `${SOLVER_PHP_API_URL}/step.php`,
      {
        action: 'step',
        bookId: bookCode,
        puzzleId: String(puzzleNumber),
        stepIndex,
      },
      { credentials: 'same-origin' }
    );
  }

  return postJson(`${SOLVER_URL}/api/solve/${solverFamilyPath(solverFamily)}/next-step`, {
    bookCode,
    accessToken,
    puzzleNumber,
    stepIndex,
  });
};

export const unlockSnowflakeBook = (payload) =>
  unlockBookSolver({ ...payload, solverFamily: 'snowflake' });
export const loadSnowflakePuzzle = (payload) =>
  loadBookPuzzle({ ...payload, solverFamily: 'snowflake' });
export const fetchSnowflakeStep = (payload) =>
  fetchBookStep({ ...payload, solverFamily: 'snowflake' });

export { API_URL, SOLVER_API_MODE, SOLVER_PHP_API_URL, SOLVER_URL };
